module.exports = __webpack_public_path__ + "images/6765a79db7dfecb3c44ce2a195923c4d-logo_white.png";